module.exports = __webpack_public_path__ + "1ed1aa580543899faecc642e678eb1ab.png";